/** Spec R header tire finder — v2026-05-30 */
(function () {
  if (window.__specrHeaderFinderInit) return;
  window.__specrHeaderFinderInit = true;

  var drawer = document.getElementById("specr-finder-drawer");
  if (!drawer) return;

  function parkDrawer() {
    if (drawer.parentNode !== document.body) {
      document.body.appendChild(drawer);
    }
  }

  parkDrawer();

  var openBtns = document.querySelectorAll("[data-specr-finder-open]");
  var closeBtns = drawer.querySelectorAll("[data-specr-finder-close]");
  var tabs = drawer.querySelectorAll("[data-specr-finder-tab]");
  var panels = drawer.querySelectorAll("[data-specr-finder-panel]");
  var finderForm = document.querySelector("[data-specr-finder-form]");
  var finderInput = document.querySelector("[data-specr-finder-input]");

  function openDrawer(preferredTab) {
    parkDrawer();
    drawer.removeAttribute("hidden");
    drawer.style.display = "";
    drawer.classList.add("is-open");
    document.body.style.overflow = "hidden";
    openBtns.forEach(function (b) {
      b.setAttribute("aria-expanded", "true");
    });
    if (preferredTab) {
      activateTab(preferredTab);
    }
  }

  function closeDrawer() {
    drawer.classList.remove("is-open");
    document.body.style.overflow = "";
    openBtns.forEach(function (b) {
      b.setAttribute("aria-expanded", "false");
    });
    setTimeout(function () {
      if (!drawer.classList.contains("is-open")) {
        drawer.setAttribute("hidden", "");
        drawer.style.display = "none";
      }
    }, 300);
  }

  function activateTab(tabId) {
    tabs.forEach(function (tab) {
      var on = tab.getAttribute("data-specr-finder-tab") === tabId;
      tab.classList.toggle("is-active", on);
      tab.setAttribute("aria-selected", on ? "true" : "false");
    });
    panels.forEach(function (panel) {
      panel.hidden = panel.getAttribute("data-specr-finder-panel") !== tabId;
    });
  }

  openBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      openDrawer();
    });
  });
  closeBtns.forEach(function (btn) {
    btn.addEventListener("click", closeDrawer);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && drawer.classList.contains("is-open")) closeDrawer();
  });

  tabs.forEach(function (tab) {
    tab.addEventListener("click", function () {
      activateTab(tab.getAttribute("data-specr-finder-tab"));
    });
  });

  /* Tire size pattern: 225/60R17, 225-60-17, 225 60 17, 35/12.5R20, etc. */
  var TIRE_SIZE_RE = /^\s*(\d{2,3})\s*[\/\-\s]?\s*(\d{2}(?:\.\d)?)\s*[\/\-\s]?[rR]?\s*(\d{2})\s*$/;
  var VEHICLE_HINT_RE = /^\s*(19|20)\d{2}\s+.+/i;
  var VIN_RE = /^[A-HJ-NPR-Z0-9]{11,17}$/i;

  function normalizeTireSize(raw) {
    var m = String(raw || "").trim().match(TIRE_SIZE_RE);
    if (!m) return null;
    return m[1] + "/" + m[2] + "R" + m[3];
  }

  function looksLikeVehicleQuery(raw) {
    var s = String(raw || "").trim();
    if (!s) return false;
    if (VIN_RE.test(s.replace(/\s+/g, ""))) return true;
    if (VEHICLE_HINT_RE.test(s)) return true;
    return false;
  }

  function navigateToSize(size) {
    window.location.href = "/pages/tire-results?size=" + encodeURIComponent(size);
  }

  function handleFinderQuery(raw) {
    var value = String(raw || "").trim();
    if (!value) {
      openDrawer();
      return;
    }

    var size = normalizeTireSize(value);
    if (size) {
      navigateToSize(size);
      return;
    }

    if (looksLikeVehicleQuery(value)) {
      openDrawer("vehicle");
      return;
    }

    /* Fallback: only navigate as size if it looks numeric-only (e.g. "2256017") */
    if (/\d/.test(value)) {
      var cleaned = value.replace(/\s+/g, "");
      if (/^\d{5,7}$/.test(cleaned) || /^\d{2,3}[\/-]\d{2,3}[\/-]?\d{2}$/.test(cleaned)) {
        navigateToSize(cleaned);
        return;
      }
    }

    openDrawer();
  }

  if (finderForm) {
    finderForm.addEventListener("submit", function (e) {
      e.preventDefault();
      handleFinderQuery(finderInput ? finderInput.value : "");
    });
  }

  if (typeof window !== "undefined") {
    window.SpecrFinderDrawer = {
      close: closeDrawer,
      open: openDrawer,
      handleQuery: handleFinderQuery,
    };
  }
})();
